import Admin from "@/views/admin/Admin.vue";
import { ADMIN_ROLE } from "@/services/constants";
import EligibilityJob from "@/views/admin/EligibilityJob.vue";

//admin routes are always the last routes
const baseAdminOrder = 900;

const adminRoute = {
  path: "/admin",
  name: "admin",
  component: Admin,
  meta: {
    humanName: "Admin",
    navbarMenu: {
      name: "Admin",
      order: baseAdminOrder + 1,
      icon: "mdi-account-cog-outline",
      iconStyles: "opacity:50%"
    },
    roles: ADMIN_ROLE
  }
};

const eligibilityJobRoute = {
  path: "/jobs/eligibility/:jobId",
  name: "Eligibility Job",
  component: EligibilityJob,
  props: true,
  meta: {
    humanName: "Eligibility Job",
    roles: ADMIN_ROLE
  }
};

export const defaultAdminRoute = adminRoute;

export const AdminRoutes = [eligibilityJobRoute, adminRoute];
